import { io, Socket } from 'socket.io-client';

let socketInstance: Socket | null = null;

export const useSocketService = (): Socket => {
  // Return existing socket (connected OR reconnecting — don't create a new one)
  if (socketInstance) {
    return socketInstance;
  }
  
  const socketUrl: string = import.meta.env.VITE_SOCKET_URL as string;
  
  // Při inicializaci připojení přidejte `auth` objekt
  socketInstance = io(socketUrl, {
    auth: {
      type: "intranet",
    },
    query: {
      //"my-key": "my-value",
    },
    withCredentials: false,
    transports: ["websocket"],
    reconnection: true,
    reconnectionAttempts: Infinity,
    reconnectionDelay: 1000,
    reconnectionDelayMax: 10000,
  });

  socketInstance.on('connect', () => {
    console.log('Connected to WebSocket server');
  });

  socketInstance.on('disconnect', (reason) => {
    console.log('Disconnected from WebSocket server:', reason);
  });

  return socketInstance;
};

export const disconnectSocket = () => {
  if (socketInstance) {
    socketInstance.disconnect();
    socketInstance = null;
  }
};
